<template>
  <div>
    <base-button icon="mdi-plus" @click="isDialogVisible = true">
      {{ $i18n.t('default.create') }}
    </base-button>
    <add-edit-feature-dialog
      v-if="isDialogVisible !== null"
      :is-visible.sync="isDialogVisible"
      :feature-data="addFeatureData"
      :title="$i18n.t('dialog.cases.quickAddingTitle')"
      agree-text="default.create"
      @done="onFeatureAdded"
    >
      <template #prepend_form>
        <div>
          <v-alert icon="mdi-information-outline" type="info" style="font-size: 12px" class="text-left my-5" dense text>
            {{ $i18n.t('dialog.cases.quickAddingInfo') }}
          </v-alert>
        </div>
      </template>
    </add-edit-feature-dialog>
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify';

export default {
  name: 'QuickCaseAdding',
  components: {
    AddEditFeatureDialog: () => import('@/components/AddEditFeatureDialog'),
  },
  props: {},
  data: () => ({
    isDialogVisible: false,
  }),
  computed: {
    layers: get('layers/layers'),
    casesDatasourceName: get('cases/getCasesDatasourceName'),
    casesLayerId: get('cases/getCasesLayerId'),
    addFeatureData() {
      return {
        datasource: this.casesDatasourceName,
        layer: this.casesLayerId,
      };
    },
    toolbarGeometries: get('map/toolbarGeometries'),
    toolbarGeometriesRelations() {
      const toolbarGeometriesFeatures =
        this.toolbarGeometries?.geojson?.features?.filter(feature => feature.properties?.relation) || [];
      return toolbarGeometriesFeatures.map(({ properties: { relation } }) => {
        const { layerId, featureId } = relation;
        return {
          data_source_name: this.layers[layerId]?.data_source_name,
          layer_id: layerId,
          feature_id: featureId,
        };
      });
    },
  },
  methods: {
    addRelation: call('relations/addRelation'),
    async onFeatureAdded(callback, _, featureId) {
      if (this.toolbarGeometriesRelations.length > 0) await this.assignByFeatureId(featureId);
      if (this.$route.params.lid === this.casesLayerId) this.$root.$emit('refreshTableData');
      callback?.();
    },
    async assignByFeatureId(featureId) {
      try {
        const payload = {
          data_source_name: this.casesDatasourceName,
          feature_id: featureId,
          features: this.toolbarGeometriesRelations,
        };
        await this.addRelation(payload);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
